const currencyList = {
  usd: {
    code: 'usd',
    minimumStripeChargeAmount: 50,
  },
  aed: {
    code: 'aed',
    minimumStripeChargeAmount: 2000,
  },
  aud: {
    code: 'aud',
    minimumStripeChargeAmount: 50,
  },
  brl: {
    code: 'brl',
    minimumStripeChargeAmount: 50,
  },
  cad: {
    code: 'cad',
    minimumStripeChargeAmount: 50,
  },
  chf: {
    code: 'chf',
    minimumStripeChargeAmount: 50,
  },
  clp: {
    code: 'clp',
    minimumStripeChargeAmount: 50,
  },
  czk: {
    code: 'czk',
    minimumStripeChargeAmount: 1500,
  },
  dkk: {
    code: 'dkk',
    minimumStripeChargeAmount: 250,
  },
  eur: {
    code: 'eur',
    minimumStripeChargeAmount: 50,
  },
  gbp: {
    code: 'gbp',
    minimumStripeChargeAmount: 30,
  },
  hkd: {
    code: 'hkd',
    minimumStripeChargeAmount: 400,
  },
  inr: {
    code: 'inr',
    minimumStripeChargeAmount: 3500,
  },
  jpy: {
    code: 'jpy',
    minimumStripeChargeAmount: 50,
  },
  mxn: {
    code: 'mxn',
    minimumStripeChargeAmount: 1000,
  },
  myr: {
    code: 'myr',
    minimumStripeChargeAmount: 200,
  },
  nok: {
    code: 'nok',
    minimumStripeChargeAmount: 300,
  },
  nzd: {
    code: 'nzd',
    minimumStripeChargeAmount: 50,
  },
  php: {
    code: 'php',
    minimumStripeChargeAmount: 3000,
  },
  pln: {
    code: 'pln',
    minimumStripeChargeAmount: 200,
  },
  ron: {
    code: 'ron',
    minimumStripeChargeAmount: 200,
  },
  sek: {
    code: 'sek',
    minimumStripeChargeAmount: 300,
  },
  sgd: {
    code: 'sgd',
    minimumStripeChargeAmount: 50,
  },
  zar: {
    code: 'zar',
    minimumStripeChargeAmount: 1000,
  },
};

export { currencyList };
